import React from "react";

const Review = () => {
  return <section>Reviews here</section>;
};

export default Review;
